export default {
  login_mfa: {
    title: '@:login.title',
    message: 'SMS dengan kode verifikasi telah \ndikirim ke nomor telepon \nAnda yang terdaftar',
    button_submit: '@:login.login',
    button_resend: 'Kirim ulang kode verifikasi',
    alert_success: 'Kode verifikasi telah dikirim ulang',
    alert_error: 'Pengiriman ulang kode verifikasi telah gagal',
    error: '@:common.error.code_9999',
    no_phone_number_message: 'Autentikasi SMS tidak dapat digunakan karena nomor telepon pengguna tidak terdaftar.\n\nHubungi administrator perusahaan Anda untuk menambahkan nomor telepon Anda.',
  },
}
